// data/email/email.js

export const defaultEmails = [];

export const emailCategory = [
  { title: 'Inbox', icon: 'material-symbols:inbox-outline-rounded' },
  { title: 'Starred', icon: 'material-symbols:star-rate-outline-rounded' },
  // { title: 'Snoozed', icon: 'material-symbols:snooze-outline-rounded' },
  // { title: 'Sent', icon: 'material-symbols:send-outline-rounded' },
  // { title: 'Draft', icon: 'material-symbols:draft-outline-rounded' },
  { title: 'Important', icon: 'material-symbols:label-important-outline-rounded' },
  // { title: 'Spam', icon: 'material-symbols:report-outline-rounded' },
  // { title: 'Archived', icon: 'material-symbols:archive-outline-rounded' },
  // { title: 'Trash', icon: 'material-symbols:delete-outline-rounded' },
];

// 🚀 EXPERT FIX: Wipe the dummy data array so your live API takes over completely!
export const emails = [];